package org.example.project.model

import kotlinx.serialization.Serializable

@Serializable
data class User(
    val uid: String = "",
    val email: String = "",
    val username: String = "",
    val photoUrl: String = "",
    val wins: Int = 0,
    val losses: Int = 0,
    val score: Int = 0,
    val gamesPlayed: Int = 0,
    val rating: Int = 1000,
    val online: Boolean = false,
    val inGame: Boolean = false,
    val lastSeen: Double = 0.0
)